import { Button, Spinner } from '@1trading/react';
import { QueryErrorBanner } from '@/components/feedback/query-error';

interface ErrorPanelProps {
  /** Legacy toast copy, e.g. "Failed to fetch fee bands" */
  title: string;
  error: unknown;
  onRetry: () => void;
}

/**
 * @deprecated Superseded by the shared QueryErrorBanner — this file
 * originally hand-rolled the same Alert + Retry markup that QueryErrorBanner now
 * owns. Kept as a thin re-export because trades-tab.tsx, clients-tab.tsx,
 * transactions-tab.tsx, fee-bands-tab.tsx, and pages/operations/broker-detail.tsx
 * import it and are out of scope for this wave; migrate those call sites to
 * QueryErrorBanner directly and delete this wrapper.
 */
export const ErrorPanel = ({ title, error, onRetry }: ErrorPanelProps) => <QueryErrorBanner error={error} onRetry={onRetry} title={title} />;
ErrorPanel.displayName = 'ErrorPanel';

interface LoadMoreButtonProps {
  /** Render only while the dataset's cursor exists. */
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
}

/** Centered outlined Load More — the shared pattern for every list on the detail page. */
export const LoadMoreButton = ({ hasNextPage, isFetchingNextPage, onLoadMore }: LoadMoreButtonProps) => {
  if (!hasNextPage) return null;
  return (
    <div className="flex justify-center">
      <Button className="gap-2" disabled={isFetchingNextPage} onClick={onLoadMore} type="button" variant="outline">
        {isFetchingNextPage ? <Spinner className="size-4" /> : null}
        Load More
      </Button>
    </div>
  );
};
LoadMoreButton.displayName = 'LoadMoreButton';
